// @flow
import client from '../../client'

// Types
export type Geolocation = {
  country_code: string,
  country_name: string,
  currency_code: string,
}

// API Endpoints
export const GEOLOCATION_ENDPOINT = '/geolocation/'

/**
 * Returns object with country code, name and
 * currency country_code based on the IP address
 * @return {Promise} A resolved Promise with an object
 */

export const getGeolocation = (): Promise<Geolocation> =>
  client.get(GEOLOCATION_ENDPOINT)

export default getGeolocation
